<template lang="pug">
	.upload-button
		.icon(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Upload code'}" v-pseudo-modal-show="'upload-dropdown'")
			.fa.fa-upload
		.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'upload-dropdown'")
			.dropdown-header(class="text-center")
				strong Upload creative
			.networks(v-bar)
				.networks-content
					.dropdown-item(@click="uploadCreative('amazon')" v-if="Server.Config['amazon-s3-bucket-name']")
						.item-title Amazon S3
						.item-icon(v-bind:style="{backgroundImage: 'url(/img/icons/services/amazon.png)', width: '46px'}")
						.item-description.text-muted Upload to Amazon S3 bucket
					.dropdown-item(@click="uploadCreative('server')")
						.item-title PRVK Server
						.item-icon(v-bind:style="{backgroundImage: 'url(/img/logo/prvk-white.png)', width: '76px'}")
						.item-description.text-muted Upload to venatusmedia.com server
					.dropdown-item(@click="uploadCreative('test')")
						.item-title TamperMonkey
						.item-icon(v-bind:style="{backgroundImage: 'url(/img/logo/tampermonkey.png)', width: '46px'}")
						.item-description.text-muted Upload to TamperMonkey for testing
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Server } 			from '../../services/Server'
	import { Template } 		from '../../services/Template'

	export default {
		name: "UploadButton",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Project Changed"]
		},
		data() {

			this.Server = Server;
			this.Template = Template;

			return {
				showed: true
			};

		},
		methods: {
			uploadCreative(type) {

				switch (type) {

					case 'amazon':
						Broadcast.call("Show Upload Amazon S3");
						break;

					case 'server':
						Broadcast.call("Show Upload Server");
						break;

					case 'test':
						Broadcast.call("Show Upload Test");
						Broadcast.call("Upload Test");
						break;
				}

				Broadcast.call("Pseudo Modal Hide", ['upload-dropdown']);

			}
		}
	}
</script>


<style lang="sass">

	.upload-button
		list-style: none
		position: relative

		.dropdown-menu
			position: absolute
			left: -230px
			top: 40px
			display: block
			z-index: 10000
			line-height: 1.5
			width: 250px
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

			.dropdown-header
				cursor: default

			.networks
				height: auto
				overflow-x: hidden
				overflow-y: auto

				.dropdown-item
					white-space: normal
					padding: 0px 20px 10px 20px
					width: 250px

				.item-title
					margin-bottom: 5px
					padding-top: 5px

				.item-description
					white-space: normal
					line-height: 12px
					font-size: 0.6rem
					width: 66%

				.item-icon
					position: absolute
					top: 5px
					right: 10px
					width: calc(37% - 10px)
					height: 44px
					opacity: 1
					background-size: contain
					background-repeat: no-repeat
					background-position: right center
					max-height: 55px

			.networks::-webkit-scrollbar
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			.networks::-webkit-scrollbar-track
				background-color: rgba(255,255,255,0.3)
				border-right: 1px solid #f2f2f2
				border-left: 1px solid #f2f2f2

			.networks::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(255,255,255,0.2)
				background-clip: content-box
				border-color: transparent
				border-style: solid
				border-width: 1px 2px

</style>

